import React, { useState } from 'react'
import { AntTabs, AntTab } from './common/Tabs'
import { DashboardAthenaTable } from './DashboardAthenaTable'
import { resourceWorkAssignmentCols } from '../constants/ResourceCols'
import ResourceWorkAssignmentAuditLog from './ResourceWorkAssignmentAuditLog'

const tabs = [
  { display: 'Main', value: 0 },
  { display: 'Audit Log', value: 1 }
]

export default function ResourceWorkAssignments(props) {
  const [value, setValue] = useState(0)
  const { headers, tableRefreshKey } = props

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <>
      <AntTabs
        color={props.fetchInitialData.credentials.primaryAppColor}
        value={value}
        onChange={handleChange}
        aria-label='work assignments tabs'
      >
        {tabs.map((cur, index) => (
          <AntTab
            key={index}
            label={cur.display}
            value={cur.value}
            color={props.fetchInitialData.credentials.primaryAppColor}
          />
        ))}
      </AntTabs>
      {value === 0 && (
        <div style={{ marginTop: '1rem' }}>
          <DashboardAthenaTable
            {...props}
            isTempTable={false}
            key={`workassignment-main-${tableRefreshKey}`}
            params={{ ...headers }}
            tableColumns={resourceWorkAssignmentCols}
            reportName='hr_resource_workassignment_main'
          />
        </div>
      )}
      {value === 1 && (
        <div style={{ marginTop: '1rem' }}>
          <ResourceWorkAssignmentAuditLog {...props} />
        </div>
      )}
    </>
  )
}
